let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jaRwE")).then(() => parcelRequire('h0oyE'));